// extracted by mini-css-extract-plugin
export default {"card":"card1_card__fSMGY","box":"card1_box__-w9rg","boxContent":"card1_boxContent__Djrl3","line":"card1_line__CBF2B"};